const TIMEOUT_MS = 15000

const OPTIONS: PositionOptions = {
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: TIMEOUT_MS,
}

export type GeoStatus = 'CURRENT' | 'LAST_KNOWN' | 'NONE'

export const ERROR_NO_GEOLOCATION_CODE = 4 as const

export interface CustomGeolocationError {
    code: number
    message: string
}

// Mimics GeolocationPositionError object
const ERROR_NO_GEOLOCATION: CustomGeolocationError = {
    code: ERROR_NO_GEOLOCATION_CODE,
    message: 'No geolocation object in navigator',
}

// See https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
export const EXTENDED_GEOLOCATION_POSITION_ERROR_MAP = {
    1: 'PERMISSION_DENIED',
    2: 'POSITION_UNAVAILABLE',
    3: 'TIMEOUT',
    [ERROR_NO_GEOLOCATION_CODE]: 'NO_GEOLOCATION',
} as const

export type GeoErrorCode = keyof typeof EXTENDED_GEOLOCATION_POSITION_ERROR_MAP
export type GeoErrorValue = typeof EXTENDED_GEOLOCATION_POSITION_ERROR_MAP[GeoErrorCode]

/**
 * Wraps navigator.geolocation.getCurrentPosition in a typed Promise.
 */
export function getLocationFromNavigator(): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(resolve, reject, OPTIONS)
    } else {
      reject(ERROR_NO_GEOLOCATION)
    }
  })
}